import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Home from "./pages/Home/home";
import Only from "./pages/Only/only";
import Programacao from "./pages/Programacao/programacao";
import { analysticsEvent } from "./services/index";

const _redirect = async (event, link) => {
  try {
    await analysticsEvent(event);
  } catch (err) {
  } finally {
    window.location.replace(link);
  }
  return <></>;
};

const Routes = () => (
  <Router>
    <Route path="/" exact component={Home} />

    <Route path="/only" component={Only} />
    <Route path="/onlyfans" component={Only} />
    <Route path="/privacy" component={Only} />
    <Route path="/programacao" component={Programacao} />

    <Route
      path="/live"
      component={() =>
        _redirect("REDIRECT_LIVE", "https://www.twitch.tv/lipinho")
      }
    />

    <Route
      path="/donate"
      component={() =>
        _redirect("REDIRECT_DONATE", "https://www.streamar.com.br/LipinhO")
      }
    />

    <Route
      path="/store"
      component={() =>
        _redirect("REDIRECT_STORE", "https://streamelements.com/lipinhor/store")
      }
    />

    <Route
      path="/loja"
      component={() =>
        _redirect("REDIRECT_LOJA", "https://streamelements.com/lipinhor/store")
      }
    />

    <Route
      path="/youtube"
      component={() =>
        _redirect("REDIRECT_COMMANDS", "https://www.youtube.com/@LipinhO")
      }
    />

    <Route
      path="/instagram"
      component={() =>
        _redirect("REDIRECT_INSTAGRAM", "https://www.instagram.com/_lipinho")
      }
    />

    <Route
      path="/facebook"
      component={() =>
        _redirect("REDIRECT_FACEBOOK", "https://www.facebook.com/LiipinhO")
      }
    />

    <Route
      path="/dc"
      component={() =>
        _redirect("REDIRECT_DC", "https://discord.com/invite/boteco-do-lipinho-852868481350500392")
      }
    />

    <Route
      path="/discord"
      component={() =>
        _redirect("REDIRECT_DISCORD", "https://discord.com/invite/boteco-do-lipinho-852868481350500392")
      }
        
    />
    <Route
      path="/1xbet"
      component={() =>
        _redirect("REDIRECT_1XBET", "https://clcr.me/jPv52h")
      }
        
    />        
    <Route
      path="/8787bet"
      component={() =>
        _redirect("REDIRECT_8787BET", "https://www.8787bet9.com/spread?pid=1172106079")
      }
    />        

    <Route
      path="/leon"
      component={() =>
        _redirect("REDIRECT_LEONBET", "https://bit.ly/45nXQRv")
      }
    />       

    <Route
      path="/bet"
      component={() =>
        _redirect("REDIRECT_LEONBET", "https://bit.ly/45nXQRv")
      }
    />    

    <Route
      path="/leonbet"
      component={() =>
        _redirect("REDIRECT_LEONBET", "https://bit.ly/45nXQRv")
      }
    />      
        
    <Route
      path="/lottu"
      component={() =>
        _redirect("REDIRECT_LOTTU", "https://www.lottu.bet.br/register?affiliate_id=69b9a5df749280000ae03075&ngx_campaign_id=6a9ad94fedb01682a264516b&ngx_source_id=LIPINHO")
      }
    />    

    <Route
      path="/tada"
      component={() =>
        _redirect("REDIRECT_TADA", "https://9f.bet.br/r/BwWpPRia")
      }
    />    
        
    <Route
      path="/doar"
      component={() =>
        _redirect("REDIRECT_DOAR", "https://streamar.com.br/LipinhO")
      }
    />

    <Route
      path="/doacao"
      component={() =>
        _redirect("REDIRECT_DOACAO", "https://streamar.com.br/LipinhO")
      }
    />
    <Route
      path="/pix"
      component={() => _redirect("REDIRECT_PIX", "https://livepix.gg/lipinho")}
    />

    <Route
      path="/tiktok"
      component={() =>
        _redirect("REDIRECT_TIKTOK", "https://www.tiktok.com/@lipinhox")
      }
    />

    <Route
      path="/telegram"
      component={() =>
        _redirect("REDIRECT_TELEGRAM", "https://t.me/+ps1YQcVkxgI5YTRh")
      }
    />
        
    <Route
      path="/canalinstagram"
      component={() =>
        _redirect("REDIRECT_CANALINSTA", "https://ig.me/j/AbagKTXjuEFleRSi/")
      }
    />
        
    <Route
      path="/onestate"
      component={() =>
        _redirect("REDIRECT_ONESTATE", "https://onestate.onelink.me/nWr0/lipinho")
      }
    />

    <Route
      path="/lagofast"
      component={() =>
        _redirect("REDIRECT_LAGOFAST", "https://www.lagofast.com/pt-br/?cid=712")
      }
    />    
    
    <Route
      path="/onestaterp"
      component={() =>
        _redirect("REDIRECT_ONESTATERP", "https://onestate.onelink.me/nWr0/lipinho")
      }
    />
        
    <Route
      path="/loco"
      component={() =>
        _redirect("REDIRECT_LOCO", "https://loco.com/streamers/lipinho")
      }
    />
        
    <Route
      path="/pocketbroker"
      component={() =>
        _redirect("REDIRECT_LOCO", "https://bit.ly/4mG9KgY")
      }
    />
        
  </Router>
);

export default Routes;
